import type { FaireProductEntity } from "../../entity_types/product";

export const p_ut3tbs6mrw: FaireProductEntity = {
  token: "p_ut3tbs6mrw",
  type: "product",
  name: "Evereign 18K Gold Non-Tarnish Knot Necklace",
  brandToken: "b_3tzh9mjdm6",
  brandName: "Flânerie by MAIQ",
  imageUrl:
    "https://cdn.faire.com/fastly/116f4dfe5ac4b6853d12282edb23907dcf770883759c90b506eb822b0dceeeec.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/2a1326157da009a984415c61a1e2310562ae16a56d4fc159039e460f72af53be.jpeg",
    "https://cdn.faire.com/fastly/e6510bca98adc913f5ac88e7be48a598d4da64028ccc03891371eef8cdc73073.jpeg",
    "https://cdn.faire.com/fastly/ff05cc208673cf61b8e3e7dbcf70bd6252389979df25df115bfe1ce8a4c10037.jpeg",
  ],
  priceDollars: 8.16,
  description:
    "18K Gold Non-Tarnish Knot Necklace\n18K Gold Plating\nStainless Steel\nPendant Size (inch): 0.59 Diameter\nChain Length (inch): 14.96\nExtension Length (inch): 1.97\n \n- Lead and Nickel Free\n- Hypoallergenic\n- Water Resistant",
  tags: [],
  msrpDollars: 28,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:54:43.159Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
